import { render } from "./RowItem.vue?vue&type=template&id=1c37e6e3&scoped=true"
import script from "./RowItem.vue?vue&type=script&lang=js"
export * from "./RowItem.vue?vue&type=script&lang=js"

import "./RowItem.vue?vue&type=style&index=0&id=1c37e6e3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c37e6e3"]])

export default __exports__